import React, { useEffect, useState, useRef } from "react";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "./swiper.css";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import {
  EffectFade,
  Navigation,
  Pagination,
  Autoplay,
  EffectCoverflow,
  EffectCreative,
} from "swiper/modules";
import AOS from "aos";
import "aos/dist/aos.css";
import Button from "../Button/Button";
import Chart from "./Chart";
import { Circle, Facebook, Flag, Linkedin, Twitter } from "react-feather";
import Second from "../../assets/images/home/thirdSection/2.jpg";
import Banner from "../../assets/images/blog/user-img-1.jpg";
import tables from "../../assets/images/blog/tables.jpg";
import img3 from "../../assets/images/blog/blog-titleimg.jpg";
import ImageReactangle from "../Contact/ImageReactangle";
import Image from "../Contact/Image";
import Footer from "../footer";
import brand from "../../brandConfig";
import B1 from "../../assets/images/flags/air-canada-logo-tail.png";
import B2 from "../../assets/images/flags/alliance-air-logo-tail.png";
import B3 from "../../assets/images/flags/american-airlines-logo-tail.png";
import B4 from "../../assets/images/flags/british-airways-logo-tail.png";
import B5 from "../../assets/images/flags/cathay-pacific-logo-tail.png";
import B6 from "../../assets/images/flags/delta-logo-tail.png";
import B7 from "../../assets/images/flags/easyjet-logo-tail.png";
import B8 from "../../assets/images/flags/emirates-logo-tail.png";
import B9 from "../../assets/images/flags/etihad-airways-logo-tail.png";

import B11 from "../../assets/images/flags/jetblue-logo-tail.png";

import B13 from "../../assets/images/flags/lufthansa-logo-tail.png";
import B14 from "../../assets/images/flags/pegasus-airlines-logo-tail.png";
import B15 from "../../assets/images/flags/qantas-logo-tail.png";
import B16 from "../../assets/images/flags/qatar-airways-logo-tail.png";
import B17 from "../../assets/images/flags/ryanair-uk-logo-tail.png";
import B18 from "../../assets/images/flags/saudia-logo-tail.png";
import B19 from "../../assets/images/flags/singapore-airlines-logo-tail.png";
import B20 from "../../assets/images/flags/turkish-airlines-logo-tail.png";
import B21 from "../../assets/images/flags/united-airlines-logo-tail.png";
import B22 from "../../assets/images/flags/wizz-air-logo-tail.png";
import Bg1122 from "../../assets/images/banner/bg1122.jpeg";

import planDep from "../../assets/images/banner/planeDep.svg";
import planAri from "../../assets/images/banner/planeAri.svg";
import HeadingSep from "../../assets/images/banner/heading-sep.png";
import cusImg from "../../assets/images/banner/customize-umrah.png";
import Datepicker from "./Datepicker";
import service from "../../Service/Service";
import CustomizeSection from "./CustomizeSection";
import Navbar from "../navbar";
import InputSection from "./InputSection";
import { Link } from "react-router-dom";
import CardsSection from "./CardsSection";
import CategorySection from "./CategorySection";
import UmrahPackageCard from "./UmrahPackageCard";
import HolidayPackageCard from "./HolidayPackageCard";
import { BadgePoundSterling, Compass, CreditCard, Globe, Headset, LifeBuoy, MapPin, MonitorCog, PhoneCall, Share, Share2, Umbrella, DollarSign, Phone, Award, ShieldX } from "lucide-react";
import BannerSection from "./BannerSection";
import parse from 'html-react-parser';
import AllPackagesHP from '../AllPackagesHomePage/AllPackagesHP';
import DealsSection from './DealsSection';
import PageDealsSection from './PageDealsSection';

const TopSection = (props) => {
  const [categories, setCategories] = useState([]);
  const [packages, setPackages] = useState([]);
  const [umrahPackages, setUmrahPackages] = useState([]);
  const [holidayPackages, setHolidayPackages] = useState([]);
  const [airportDep, setAirportDep] = useState([]);
  const [airportArv, setAirportArv] = useState([]);
  const [paras, setParas] = useState([]);
  const umrahSliderRef = useRef(null);
  const holidaySliderRef = useRef(null);
  const [umrahActivePage, setUmrahActivePage] = useState(0);
  const [holidayActivePage, setHolidayActivePage] = useState(0);
  const getCategories = () => {
    service.getAllCategory().then((response) => {
      setCategories(response.data);
    });
  };

  const getPackages = () => {
    // Fetch both regular packages and Umrah packages
    Promise.all([
      service.getAllpackage().catch(err => {
        console.error('Error fetching regular packages:', err);
        return { data: [] };
      }),
      service.getAllpackageUmrah().catch(err => {
        console.error('Error fetching Umrah packages:', err);
        return { data: [] };
      })
    ]).then(([regularResponse, umrahResponse]) => {
      const allRegular = regularResponse.data || [];
      const allUmrah = umrahResponse.data || [];
      
      console.log('All regular packages:', allRegular.length);
      console.log('All Umrah packages:', allUmrah.length);
      
      // === Featured / Display logic ===
      // Regular packages still use `featured` flag
      const featuredRegular = allRegular.filter((x) => {
        return x.featured == 1 || x.featured === true || x.featured === '1';
      });
      
      // Umrah packages now use display options instead of `featured`
      // Only show packages where Thumbnail is ON AND package_type is 'Umrah'
      const thumbnailUmrah = allUmrah.filter((x) => {
        const hasThumbnail = x.show_as_thumbnail === true || x.show_as_thumbnail === 1 || x.show_as_thumbnail === '1';
        const isUmrah = x.package_type === 'Umrah';
        return hasThumbnail && isUmrah;
      });
      
      // Holiday packages now use display options instead of `featured`
      // Only show packages where Thumbnail is ON AND package_type is 'Holiday'
      const thumbnailHoliday = allUmrah.filter((x) => {
        const hasThumbnail = x.show_as_thumbnail === true || x.show_as_thumbnail === 1 || x.show_as_thumbnail === '1';
        const isHoliday = x.package_type === 'Holiday';
        return hasThumbnail && isHoliday;
      });
      
      console.log('Featured regular packages:', featuredRegular.length);
      console.log('Thumbnail Umrah packages:', thumbnailUmrah.length);
      console.log('Thumbnail Holiday packages:', thumbnailHoliday.length);
      
      // Set packages separately
      if (featuredRegular.length > 0) {
        setPackages(featuredRegular);
      } else {
        // Fallback: show all regular packages if no featured ones exist
        setPackages(allRegular);
      }
      
      // For Umrah and Holiday, do NOT fall back to all packages - display is controlled
      // purely by the Thumbnail/Page toggles in the admin panel
      setUmrahPackages(thumbnailUmrah);
      setHolidayPackages(thumbnailHoliday);
    });
  };

  const getAllAirports = () => {
    service.getAllAirports().then((response) => {
      let dep = response.data.filter((x) => x.type == "DEPARTURE");
      let arv = response.data.filter((x) => x.type == "ARRIVAL");
      setAirportDep(dep);
      setAirportArv(arv);
    });
  };

  const getAllparas = () => {
    service.getAllparas().then((response) => {
      let dep = response.data.filter((x) => x.para_type == 'LANDING');
      setParas(dep)

    });
  };

  useEffect(() => {
    AOS.init();
    getCategories();
    getPackages();
    getAllAirports();
    getAllparas();
    // Preserve userDetailsProvided flag when clearing localStorage
    const userDetailsProvided = localStorage.getItem('userDetailsProvided');
    localStorage.clear();
    if (userDetailsProvided) {
      localStorage.setItem('userDetailsProvided', userDetailsProvided);
    }
  }, []);


  const whyChoseUs = [
    {
      heading: `Price Match Promise`,
      icon: () => { return <DollarSign className="text-white w-6 h-6" /> },
      para: `Find great flight deals to destinations worldwide`,
    },
    {
      heading: `24/7 Customer Support`,
      icon: () => { return <Phone className="text-white w-6 h-6" /> },
      para: `Speak to our travel experts: anytime, anywhere`,
    },
    {
      heading: `ClubMiles Rewards`,
      icon: () => { return <Award className="text-white w-6 h-6" /> },
      para: `Earn points and air miles to maximize your rewards`,
    },
    {
      heading: `Easy Cancellations`,
      icon: () => { return <ShieldX className="text-white w-6 h-6" /> },
      para: `Convenient options online and 24/7 Customer Support`,
    },
  ]

  return (
    <div>
      <Navbar bg={1} />
      <BannerSection />

      <div className="w-[92%] md:w-[80%] mx-auto -mt-6 md:-mt-2 mb-6">
        <div className="bg-gray-50 rounded-xl p-4 md:p-6 shadow-md">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {
              whyChoseUs.map((p, index) => {
                return (
                  <div key={index} className="flex items-start gap-4">
                    <div className="flex-shrink-0">
                      <div className="bg-secondary rounded-full p-3 flex justify-center items-center h-12 w-12 shadow-sm">
                        {p.icon()}
                      </div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="font-bold text-base md:text-lg text-gray-900 leading-tight mb-1.5">{p.heading}</p>
                      <p className="text-sm md:text-base text-gray-700 leading-relaxed">{p.para}</p>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>

      {/* Thumbnail Deals Section (Today's Best Deals) */}
      <DealsSection />



      {/* <div className="w-[80%] mx-auto mt-10">
<p className="tracking-[3px] text-2xl md:text-3xl font-[600]  leading-12 mt-0 text-center">
Why To Choose Us
          </p>
          <p className="tracking-[2px] text-lg md:text-xl font-[500] leading-8 mt-2 text-center ">
          We Are Known For Travel Perfection
          </p>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-5">
        
<div
  class="m-2 group px-10 py-5 bg-white/10 rounded-lg flex flex-col items-center justify-center gap-2 relative after:absolute after:h-full after:bg-[#22c55e] z-20 shadow-lg after:-z-20 after:w-full after:inset-0 after:rounded-lg transition-all duration-300 hover:transition-all hover:duration-300 after:transition-all after:duration-500 after:hover:transition-all after:hover:duration-500 overflow-hidden cursor-pointer after:-translate-y-full after:hover:translate-y-0 [&amp;_p]:delay-200 [&amp;_p]:transition-all"
>
 <Flag className=" tracking-[2px] text-lg md:text-xl font-[500] leading-8 mt-2 text-center" size={40}/>
 <p className=" tracking-[2px] text-lg md:text-xl font-[500] leading-6 mt-2 text-center">Tell Us What You Want To Do</p>
</div>

<div
  class="m-2 group px-10 py-5 bg-white/10 rounded-lg flex flex-col items-center justify-center gap-2 relative after:absolute after:h-full after:bg-[#22c55e] z-20 shadow-lg after:-z-20 after:w-full after:inset-0 after:rounded-lg transition-all duration-300 hover:transition-all hover:duration-300 after:transition-all after:duration-500 after:hover:transition-all after:hover:duration-500 overflow-hidden cursor-pointer after:-translate-y-full after:hover:translate-y-0 [&amp;_p]:delay-200 [&amp;_p]:transition-all"
>
 <MapPin className=" tracking-[2px] text-xl font-[500] leading-8 mt-2 text-center" size={40}/>
 <p className=" tracking-[2px] text-xl font-[500] leading-6 mt-2 text-center">Share Your Travel Locations</p>
</div>

<div
  class="m-2 group px-10 py-5 bg-white/10 rounded-lg flex flex-col items-center justify-center gap-2 relative after:absolute after:h-full after:bg-[#22c55e] z-20 shadow-lg after:-z-20 after:w-full after:inset-0 after:rounded-lg transition-all duration-300 hover:transition-all hover:duration-300 after:transition-all after:duration-500 after:hover:transition-all after:hover:duration-500 overflow-hidden cursor-pointer after:-translate-y-full after:hover:translate-y-0 [&amp;_p]:delay-200 [&amp;_p]:transition-all"
>
 <Share2 className=" tracking-[2px] text-lg md:text-xl font-[500] leading-8 mt-2 text-center" size={40}/>
 <p className=" tracking-[2px] text-lg md:text-xl font-[500] leading-6 mt-2 text-center">
 Share Your Travel Preference</p>
</div>

<div
  class="m-2 group px-10 py-5 bg-white/10 rounded-lg flex flex-col items-center justify-center gap-2 relative after:absolute after:h-full after:bg-[#22c55e] z-20 shadow-lg after:-z-20 after:w-full after:inset-0 after:rounded-lg transition-all duration-300 hover:transition-all hover:duration-300 after:transition-all after:duration-500 after:hover:transition-all after:hover:duration-500 overflow-hidden cursor-pointer after:-translate-y-full after:hover:translate-y-0 [&amp;_p]:delay-200 [&amp;_p]:transition-all"
>
 <Compass className=" tracking-[2px] text-lg md:text-xl font-[500] leading-8 mt-2 text-center" size={40}/>
 <p className=" tracking-[2px] text-lg md:text-xl font-[500] leading-6 mt-2 text-center">
 100% Trusted Travel Agency</p>
</div>

          </div>
</div> */}

      {/* Regular Packages Section */}
      {packages.length > 0 && (
        <div className="mt-12 mb-12 w-[90%] md:w-[80%] mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-8">Featured Packages</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-5">
            {packages.map((x, index) => {
              return <CategorySection key={index} data={x} />;
            })}
          </div>
        </div>
      )}

      {/* Umrah Packages Section */}
      {umrahPackages.length > 0 && (
        <div className="mt-6 mb-12 w-[90%] md:w-[80%] mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-8">Top Umrah Packages</h2>
          
          {/* Mobile: horizontal carousel with dots */}
          <div className="md:hidden relative">
            {/* Scroll container */}
            <div
              ref={umrahSliderRef}
              className="overflow-x-auto scroll-smooth scrollbar-hide pl-3"
              onScroll={() => {
                if (umrahSliderRef.current) {
                  const { scrollLeft, clientWidth } = umrahSliderRef.current;
                  const newIndex = Math.round(scrollLeft / clientWidth);
                  const maxIndex = Math.max(umrahPackages.length - 1, 0);
                  setUmrahActivePage(Math.min(Math.max(newIndex, 0), maxIndex));
                }
              }}
            >
              <div className="flex gap-5 snap-x snap-mandatory pb-4">
                {umrahPackages.map((x, index) => {
                  const packageRating = x.category_name && x.category_name.includes('4') ? 4 : 
                                       x.category_name && x.category_name.includes('5') ? 5 : 3;
                  return (
                    <div key={index} className="snap-center shrink-0 w-[95%]">
                      <UmrahPackageCard packageData={x} rating={packageRating} />
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Dots indicator */}
            {umrahPackages.length > 1 && (
              <div className="flex justify-center gap-2 mt-2">
                {umrahPackages.map((_, i) => (
                  <span
                    key={i}
                    className={`h-1 rounded-full transition-all ${
                      i === umrahActivePage ? 'w-8 bg-secondary' : 'w-2 bg-gray-300'
                    }`}
                  />
                ))}
              </div>
            )}
          </div>

          {/* Tablet/desktop: grid layout */}
          <div className="hidden md:grid grid-cols-2 lg:grid-cols-4 gap-5">
            {umrahPackages.map((x, index) => {
              const packageRating = x.category_name && x.category_name.includes('4') ? 4 : 
                                   x.category_name && x.category_name.includes('5') ? 5 : 3;
              return <UmrahPackageCard key={index} packageData={x} rating={packageRating} />;
            })}
          </div>
        </div>
      )}

      {/* Holiday Packages Section */}
      {holidayPackages.length > 0 && (
        <div className="mt-12 mb-12 w-[90%] md:w-[80%] mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-8">Top Holiday Packages</h2>
          
          {/* Mobile: horizontal carousel with dots */}
          <div className="md:hidden relative">
            {/* Scroll container */}
            <div
              ref={holidaySliderRef}
              className="overflow-x-auto scroll-smooth scrollbar-hide pl-3"
              onScroll={() => {
                if (holidaySliderRef.current) {
                  const { scrollLeft, clientWidth } = holidaySliderRef.current;
                  const newIndex = Math.round(scrollLeft / clientWidth);
                  const maxIndex = Math.max(holidayPackages.length - 1, 0);
                  setHolidayActivePage(Math.min(Math.max(newIndex, 0), maxIndex));
                }
              }}
            >
              <div className="flex gap-5 snap-x snap-mandatory pb-4">
                {holidayPackages.map((x, index) => {
                  const packageRating = x.category_name && x.category_name.includes('4') ? 4 : 
                                       x.category_name && x.category_name.includes('5') ? 5 : 3;
                  return (
                    <div key={index} className="snap-center shrink-0 w-[95%]">
                      <HolidayPackageCard packageData={x} rating={packageRating} />
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Dots indicator */}
            {holidayPackages.length > 1 && (
              <div className="flex justify-center gap-2 mt-2">
                {holidayPackages.map((_, i) => (
                  <span
                    key={i}
                    className={`h-1 rounded-full transition-all ${
                      i === holidayActivePage ? 'w-8 bg-secondary' : 'w-2 bg-gray-300'
                    }`}
                  />
                ))}
              </div>
            )}
          </div>

          {/* Tablet/desktop: grid layout */}
          <div className="hidden md:grid grid-cols-2 lg:grid-cols-4 gap-5">
            {holidayPackages.map((x, index) => {
              const packageRating = x.category_name && x.category_name.includes('4') ? 4 : 
                                   x.category_name && x.category_name.includes('5') ? 5 : 3;
              return <HolidayPackageCard key={index} packageData={x} rating={packageRating} />;
            })}
          </div>
        </div>
      )}

      <div className="mt-12 mb-12 w-[90%] md:w-[80%] mx-auto gap-5">
        <AllPackagesHP />

      </div>



      {/* Page Deals Section (Popular Cheap Flight Routes) - Before description */}
      <PageDealsSection />

      {/* Description section - only show if there are paragraphs */}
      {paras.length > 0 && (
        <div className="mt-12 mb-12 w-[90%] md:w-[80%] mx-auto grid grid-cols-1">
          {paras.map((x, index) => {
            return <div key={index}>{parse(x.description)}</div>
          })}
        </div>
      )}

      {/* Featured Partners Section */}
      <FeaturedPartnersSection />

      <Footer />
    </div>
  );
};

const FEATURED_PARTNERS_FALLBACK = [
  { code: 'AC', name: 'Air Canada' },
  { code: 'AA', name: 'American Airlines' },
  { code: 'BA', name: 'British Airways' },
  { code: 'CX', name: 'Cathay Pacific' },
  { code: 'DL', name: 'Delta' },
  { code: 'U2', name: 'EasyJet' },
  { code: 'EK', name: 'Emirates' },
  { code: 'EY', name: 'Etihad' },
  { code: 'B6', name: 'JetBlue' },
  { code: 'LH', name: 'Lufthansa' },
  { code: 'PC', name: 'Pegasus' },
  { code: 'QF', name: 'Qantas' },
  { code: 'QR', name: 'Qatar Airways' },
  { code: 'FR', name: 'Ryanair' },
  { code: 'SV', name: 'Saudia' },
  { code: 'SQ', name: 'Singapore Airlines' },
  { code: 'TK', name: 'Turkish Airlines' },
  { code: 'UA', name: 'United' },
  { code: 'W6', name: 'Wizz Air' },
];

const getAirlineLogoUrl = (code) =>
  code ? `https://www.gstatic.com/flights/airline_logos/70px/${code}.png` : null;

const FeaturedPartnersSection = () => {
  const displayList = [...FEATURED_PARTNERS_FALLBACK, ...FEATURED_PARTNERS_FALLBACK];

  return (
    <div className="w-full bg-white pt-12 pb-6 md:pt-16 md:pb-8 mt-6 mb-12">
      <div className="text-center mb-8 md:mb-12 px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
          Featured Partners
        </h2>
        <p className="text-lg md:text-xl text-gray-600">
          Domestic & International
        </p>
      </div>

      <div className="relative overflow-hidden w-full">
          <style>{`
            @keyframes slideLeft {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
            .marquee-container {
              display: flex;
              width: fit-content;
              animation: slideLeft 40s linear infinite;
            }
            .marquee-container:hover { animation-play-state: paused; }
            .marquee-item {
              flex-shrink: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 64px;
              padding: 0 16px;
            }
            @media (min-width: 768px) {
              .marquee-item { height: 80px; padding: 0 20px; }
            }
          `}</style>
          <div className="marquee-container">
            {displayList.map((airline, index) => {
              const src = getAirlineLogoUrl(airline.code);
              return (
                <div key={`${airline.code}-${index}`} className="marquee-item">
                  {src ? (
                    <img
                      src={src}
                      alt={airline.name}
                      title={airline.name}
                      className="max-h-full max-w-full object-contain opacity-90 hover:opacity-100 transition-opacity duration-300"
                      onError={(e) => { e.target.style.display = 'none'; }}
                    />
                  ) : (
                    <span className="text-sm font-semibold text-gray-500">{airline.code}</span>
                  )}
                </div>
              );
            })}
          </div>
      </div>
    </div>
  );
};

const BackSwiper = ({ slides }) => {


  let list = [
    B1,
    B2,
    B3,
    B4,
    B5,
    B6,
    B7,
    B8,
    B9,
    B11,
    B13,
    B14,
    B15,
    B16,
    B17,
    B18,
    B19,
    B20,
    B21,
    B22,
  ]
  return (
    <div className="mx-auto  w-[80%] h-full mt-10">

      {/* <Swiper
      slidesPerView={3}
        spaceBetween={30}
        effect={"fade"}
        navigation={true}
        autoplay={{
          delay: 4500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        modules={[EffectFade, Navigation, Pagination, Autoplay]}
        className="mySwiper"
      > */}
      <Swiper
        slidesPerView={slides}
        spaceBetween={30}
        pagination={{
          clickable: true,
        }}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        modules={[Navigation, Autoplay]}
        className="mySwiper"
      >


        {
          list.map((e, index) => {
            return <SwiperSlide key={index}>
              <img src={e} alt="" className="h-full w-full object-cover my-4" />
            </SwiperSlide>
          })
        }


      </Swiper>
    </div>
  );
};

export default TopSection;
